import axios from "axios";

function floatToLocaleString(number, byConsole = ""){
    return Number(number).toLocaleString('de-DE');
}

function promedio(number1, number2){
    return (Math.round((number1/number2) * 100)/100).toString();
}

function compare( a, b ) {
    if ( a.fecha > b.fecha ){
        return -1;
    }
    if ( a.fecha < b.fecha ){
        return 1;
    }
    return 0;
}
  

export function getDataToday(producer){
    var date = new Date ();
    var last = new Date(date.getTime() - (7 * 24 * 60 * 60 * 1000))

    var today   = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    var lastDay = last.getFullYear() + '-' + (last.getMonth() + 1) + '-' + last.getDate();

    return getReceptionsByDates(producer, lastDay, today);
}

export async function Get(url, tipo = 'NoData'){
    let response = "";

    if(tipo == 'NoData'){
        response = await axios.get(url, {headers: { 'Content-Type' : 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")}
        });

    }else if(tipo == 'Home'){
        axios.get(url, {headers: { 'Content-Type' : 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")}
        }).then((response)=>{
            sessionStorage.setItem("favorite", response.data["proveedores"][0]["proveedor"]);
        }).catch((error)=>{
            alert(error);
        });
    }
    return response.data;

}

export async function getProducers(){
    const myProducers = [];
    let sendValue = false;
    
    sendValue = await axios.get("http://api.coexca.cl/api/planteles", {headers :{ 'Content-Type' : 'application/json',
    'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")}
    }).then((response)=>{
        response.data.forEach(elem =>{
            myProducers.push({
                id: elem.id,
                nombre: elem.nombre,
                recepciones: elem.recepciones,
                rendimiento: (Math.round(elem.rendimiento * 10000) /100)
            });
        });
        return true;
    }).catch((error)=>{
        if(error.response.status === 401){
            alert("No tienes permitido acceder a esto");
            return false;
        }
    });
    
    if(sendValue)
        return myProducers;

}

export async function getReceptionsByIds(producer, idStart, idEnd, itsChecked){
    const receptions = [];
    let sendValues = false;

    if (!itsChecked){
        idEnd = idStart;
    }
    
    sendValues = await axios.get("http://api.coexca.cl/api/recepciones/entreids/?recepcionInicio="+idStart+"&recepcionTermino=" + idEnd, 
    {headers :{ 'Content-Type' : 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")}
    }).then((response) =>{
        response.data.forEach(elem =>{
            if(elem.id_plantel == producer){
                receptions.push({
                    idProducer: elem.id_plantel,
                    fecha: elem.fecha,
                    idRecepcion: elem.id,
                    totalCerdos: elem.animales_recibidos,
                    totalKilos: floatToLocaleString(elem.kilos_recepcionados),
                    rendimiento: (Math.round(elem.rendimiento * 10000) /100)
                });
            }
        });
        return true;
    }).catch((error)=>{
        if(error.response.status === 401){
            alert("No tienes permitido acceder a esto");
        }
    });
    
    if(sendValues)
        return receptions.sort(compare);
}

export async function getReceptionById(id){
    const reception = []
    let sendValues = false;

    sendValues = await axios.get("http://api.coexca.cl/api/recepcion?recepcion=" + id, 
    {headers :{ 'Content-Type' : 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")}
    }).then((response) =>{
        response.data.forEach(elem =>{
            reception.push({
                productor: elem.productor,
                idRecepcion: elem.id,
                fecha: elem.fecha,
                kgRecepcionados: floatToLocaleString(elem.kilos_recepcionados),
                kgProcesados: floatToLocaleString(elem.kilos_varas_calientes),
                kgCerdosVivos: floatToLocaleString(promedio(elem.kilos_recepcionados, elem.total)),
                kgVaraCaliente: floatToLocaleString(promedio(elem.kilos_varas_calientes , elem.total)),
                rendimiento: (Math.round(elem.rendimiento * 10000) /100),
                /*----------------------*/
                animalesTransportados: elem.total,
                animalesVivos: elem.total, /* duda */
                animalesMuertosCorral: elem.animales_muertos_corral,
                animalesCaidos: elem.animales_caidos,
                animalesMuertos: elem.animales_muertos,
                /*----------------------*/
                nombreTransportista: elem.nombre_transporte,
                rutTransportista: elem.trut,
                horaLlegada: elem.hora,
                guia: elem.guia,
                patente: elem.patente
            });
        });
        return true
    }).catch((error)=>{
        if(error.response.status === 401){
            alert("No tienes permitido acceder a esto");
        }
    });

    if(sendValues)
        return reception.sort(compare);
}

export async function getReceptions(producer, dateStart, dateEnd, reception1, reception2, type){
    const receptions = [];
    let sendValues = false;

    const arrayDateStart = dateStart.split("-");
    const arrayDateEnd = dateEnd.split("-");
    const newDateStart = arrayDateStart[2] + "-" + arrayDateStart[1] + "-" +arrayDateStart[0]
    const newDateEnd = arrayDateEnd[2] + "-" + arrayDateEnd[1] + "-" +arrayDateEnd[0]

    if(type == "To"){
        console.log("To")
        sendValues = await axios.get("http://api.coexca.cl/api/recepciones/entrefechas/?fechaInicio=" + newDateStart +"&fechaTermino=" + newDateEnd, 
        {headers :{ 'Content-Type' : 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")}
        }).then((response) =>{
            response.data.forEach(elem =>{
                if(elem.id_plantel == producer && (elem.id > reception1 && elem.id < reception2)){
                    receptions.push({
                        idProducer: elem.id_plantel,
                        fecha: elem.fecha,
                        idRecepcion: elem.id,
                        totalCerdos: elem.animales_recibidos,
                        totalKilos: floatToLocaleString(elem.kilos_recepcionados),
                        rendimiento: (Math.round(elem.rendimiento * 10000) /100) 
                    });
                }
            });
            return true;
        }).catch((error)=>{
            if(error.response.status === 401){
                alert("No tienes permitido acceder a esto");
            }
        });
    }else if(type == "From"){
        sendValues = await axios.get("http://api.coexca.cl/api/recepciones/entrefechas/?fechaInicio=" + newDateStart +"&fechaTermino=" + newDateEnd, 
        {headers :{ 'Content-Type' : 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")}
        }).then((response) =>{
            response.data.forEach(elem =>{
                if(elem.id_plantel == producer && (elem.id == reception1)){
                    receptions.push({
                        idProducer: elem.id_plantel,
                        fecha: elem.fecha,
                        idRecepcion: elem.id,
                        totalCerdos: elem.animales_recibidos,
                        totalKilos: floatToLocaleString(elem.kilos_recepcionados),
                        rendimiento: elem.rendimiento 
                    });
                }
            });
            return true;
        }).catch((error)=>{
            if(error.response.status === 401){
                alert("No tienes permitido acceder a esto");
            }
        });
    }
    if(sendValues)
        return receptions.sort(compare);

}

export async function getReceptionsByDates(producer, dateStart, dateEnd){
    const receptions = [];
    let sendValues = false;
    const arrayDateStart = dateStart.split("-");
    const arrayDateEnd = dateEnd.split("-");

    const newDateStart = arrayDateStart[2] + "-" + arrayDateStart[1] + "-" +arrayDateStart[0]
    const newDateEnd = arrayDateEnd[2] + "-" + arrayDateEnd[1] + "-" +arrayDateEnd[0]
    
    sendValues = await axios.get("http://api.coexca.cl/api/recepciones/entrefechas/?fechaInicio=" + newDateStart +"&fechaTermino=" + newDateEnd, 
    {headers :{ 'Content-Type' : 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")}
    }).then((response) =>{
        response.data.forEach(elem =>{
            if(elem.id_plantel == producer){
                receptions.push({
                    idProducer: elem.id_plantel,
                    fecha: elem.fecha,
                    idRecepcion: elem.id,
                    totalCerdos: elem.animales_recibidos,
                    totalKilos: floatToLocaleString(elem.kilos_recepcionados),
                    rendimiento: (Math.round(elem.rendimiento * 10000) /100)
                });
            }
        });
        return true;
    }).catch((error)=>{
        if(error.response.status === 401){
            alert("No tienes permitido acceder a esto");
        }
    });
    
    if(sendValues)
        return receptions.sort(compare);
}

export async function getDetailVara(id){
    const details = [];
    let sendValues = false;

    sendValues = await axios.get("http://api.coexca.cl/api/detalle-vara/?recepcion="+id, 
    {headers :{ 'Content-Type' : 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")}
    }).then((response) =>{
        response.data.forEach(elem =>{
            details.push({
                codVar: elem.CODVAR,
                descripcion: elem.Descripcion,
                peso_vc: floatToLocaleString(elem.peso_vc),
                peso_ter: floatToLocaleString(elem.Peso_TER),
                peso_vf: floatToLocaleString(elem.peso_vf),
                fecha_vc: elem.fecha_vc,
                fecha_vf: elem.fecha_vf,
                idDespacho: elem.iddespacho,
                nombre: elem.Nombre
            });
        });
        return true;
    }).catch((error)=>{
        if(error.response.status === 401){
            alert("No tienes permitido acceder a esto");
        }
    });
    
    if(sendValues)
        return details;
}